import { useContext } from 'react';

import { ConvertContext, ConvertProps } from '../contexts/Convert.context';

export const useConvert = (): ConvertProps => useContext(ConvertContext);
